import React from 'react';
import { Link } from 'react-router-dom';

const LogoIcon = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 260 260" fill="none" className="shrink-0">
    <circle cx="130" cy="130" r="130" fill="url(#mh-grad)" />
    <circle cx="130" cy="145" r="82" stroke="white" strokeWidth="4" fill="none" opacity="0.25" />
    <circle cx="130" cy="145" r="64" stroke="white" strokeWidth="2.5" fill="none" opacity="0.15" />
    <g transform="translate(85, 55)" stroke="white" strokeWidth="4.5" strokeLinecap="round" fill="none" opacity="0.95">
      <line x1="0" y1="0" x2="0" y2="55" />
      <line x1="0" y1="55" x2="0" y2="145" />
      <line x1="-11" y1="0" x2="-11" y2="40" />
      <line x1="11" y1="0" x2="11" y2="40" />
      <path d="M-11 40 Q-11 52, 0 55 Q11 52, 11 40" />
    </g>
    <g transform="translate(175, 55)" stroke="white" strokeWidth="4.5" strokeLinecap="round" fill="none" opacity="0.95">
      <line x1="0" y1="50" x2="0" y2="145" />
      <path d="M0 0 Q14 22, 0 50" />
      <line x1="0" y1="0" x2="0" y2="50" />
    </g>
    <g transform="translate(130, 35)">
      <path d="M0-22C-10-22-18-14-18-4.5c0 4.5 2.7 10 6.3 15.5s8.1 12.5 11.7 18c3.6-5.5 8.1-12.5 11.7-18S18 .5 18-4.5C18-14 10-22 0-22z" fill="white" />
      <circle cx="0" cy="-4.5" r="6.3" fill="#D65A31" />
    </g>
    <defs>
      <linearGradient id="mh-grad" x1="40" y1="40" x2="220" y2="220">
        <stop stopColor="#D65A31" />
        <stop offset="1" stopColor="#B84A28" />
      </linearGradient>
    </defs>
  </svg>
);

export const Logo = ({ linkTo = '/', showText = true, size = 32 }) => (
  <Link to={linkTo} className="flex items-center gap-2">
    <LogoIcon size={size} />
    {showText && (
      <span className="font-bold text-xl tracking-tight text-gray-900" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
        mealhoster
      </span>
    )}
  </Link>
);

export default Logo;
